import { ReactNode } from 'react'
import { Outlet } from 'react-router'

const ErrorLayout = (props: { children?: ReactNode }) => {
  return <article>{props.children || <Outlet />}</article>
}

export default ErrorLayout
